import type { ApolloClient } from '@apollo/client';
import type { lazy } from '$lib/utils/types';
import {
    type SelectJobTitle_LoadOptionQueryQuery,
    SelectJobTitle_LoadOptionQueryDocument,
    SelectJobTitle_LoadOptionsQueryDocument,
} from '$gql/graphql';

type Option = SelectJobTitle_LoadOptionQueryQuery['jobTitle'];

export async function loadOptions<A extends ApolloClient<unknown>>(
    apollo: lazy<A>,
    q: string,
): Promise<Option[]> {
    const response = await apollo().query({
        query: SelectJobTitle_LoadOptionsQueryDocument,
        variables: {
            maxPerPage: 100,
            page: 1,
            q,
        },
    });
    return response.data?.jobTitles.results ?? [];
}

export function optionToValue(option: Option): number {
    return option.id;
}

export async function valueToOption<A extends ApolloClient<unknown>>(
    apollo: lazy<A>,
    value: number,
): Promise<Option | null> {
    return (
        (
            await apollo().query({
                query: SelectJobTitle_LoadOptionQueryDocument,
                variables: { id: value },
            })
        ).data?.jobTitle ?? null
    );
}

export function valueToId(value: number): number {
    return value;
}
